// The app as index.js renders it (FE-01): inside an app-level error boundary,
// so a failure that reaches the top shows a notice with a reload instead of a
// white screen, and inside the unsaved-changes provider.
// FE-04: App is code split. The sign-in gate draws the sign-in screen with
// nobody signed in and starts App when someone is (see SignInGate.js), so the
// sign-in screen does not download the application. App loads through the
// same once-per-new-build reload as the lazy pages (FE-01), and a failure to
// load it shows the app-level notice with Reload only.
import { StrictMode, lazy } from 'react';
import { reloadOnceForNewBuild } from './chunkErrors.js';
import SignInGate from './SignInGate.js';
import { supabase } from './supabaseClient';
import { UnsavedChangesProvider } from './unsavedChanges.js';
import { WorkspaceErrorBoundary } from './WorkspaceErrorBoundary.js';

const loadApp = () => import('./App');
const App = lazy(reloadOnceForNewBuild(loadApp));
// Started when a sign-in request starts, so the code downloads while the
// password is checked. A failure here is left to App's own load above.
const preloadApp = () => { loadApp().catch(() => {}); };

export default function AppRoot() {
  return (
    <StrictMode>
      <WorkspaceErrorBoundary scope="app">
        <UnsavedChangesProvider><SignInGate supabase={supabase} App={App} preloadApp={preloadApp}/></UnsavedChangesProvider>
      </WorkspaceErrorBoundary>
    </StrictMode>
  );
}
